export default {
  h1: {
    fontWeight: 700,
    fontSize: 36
  },
  h2: {
    fontWeight: 700,
    fontSize: 24
  },
  h3: {
    fontWeight: 500,
    fontSize: 18
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '-0.06px'
  },
  h5: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.05px'
  },
  h6: {
    fontWeight: 500,
    fontSize: 13
  },
  overline: {
    fontWeight: 500
  },
    fontFamily: [
      '"Proza Libre"',
    ].join(','),
};
